import styled, { css } from 'styled-components';
import { TextStyle } from 'components/text';

export const Wrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

const Tag_isSummary = css`
  background-color: ${({ theme }) => theme.neutral_500};
  color: ${({ theme }) => theme.neutral_100};

  ${TextStyle} {
    direction: ltr;
  }
`;

export const Tag = styled.div<{ $isSummary?: boolean }>`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.neutral_300};
  border-radius: 4px;
  height: 24px;

  ${TextStyle} {
    padding: 0 8px;
    max-width: 80px;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    direction: rtl;
    text-align: left;
  }
  ${({ $isSummary }) => $isSummary && Tag_isSummary}
`;

export const RemoveButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  cursor: pointer;
  height: 100%;
  padding: 0 4px;
  border-radius: inherit;

  &:hover {
    background-color: ${({ theme }) => theme.danger_500};
    color: ${({ theme }) => theme.neutral_100};
  }
`;
